// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "df5eaffcb969eb4e05b2ae7ce9659dfd" + ".js";
};